import React, { Component } from "react";
import history from "../../login/history"
import { trackPromise, promiseTrackerHoc } from 'react-promise-tracker';
import Popup from "react-popup";
import authService from "../../../../services/login/auth.service";
import ConfigService from "../../../../services/configuracion/ConfigService";
import DataTable from "react-data-table-component";
import SubsidiosService from "../../../../services/solicitudes/SubsidiosService";
import { formatDate} from 'react-day-picker/moment';
import DatosSocio from "../../../generico/DatosSocio"
import { separadorPuntoMiles } from "../../../generico/utils/FormatoInput";
import { mayusculaPrimeraLetra } from "../../../generico/utils/FormatoInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

export default class AgregarPaso4 extends Component {
  constructor(props) {
    super(props);    
    this.state = this.getInitialState();    
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });


  getInitialState = () => ({
    datosCuenta:[]
  })  

  componentDidMount() {
 
  }

  getColumn() {
    return [
    {
      name: "concepto",
      selector: "concepto",
    },
    {
      name: "valor",
      selector: "valor",
    }]
  }
  

/*****************
 * CARGAR TABLAS *
 *****************/

  loadDataTipo() {
  
    let _itemsConfirm = [];
    
    _itemsConfirm = [
      {
        concepto: "Cuenta a Acreditar",
        valor: this.props.respuestasData.idAhorro,
      },
      { concepto: "Tipo de Subsidio", valor: this.props.respuestasData.tipoDescripcion },
      { concepto: "Clase de Subsidio", valor: this.props.respuestasData.claseDescripcion },
      { concepto: "Fecha Hecho", valor: this.props.respuestasData.fechaHecho },
    ];
      return _itemsConfirm;
    }

  loadDataSubsidio() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      { concepto: "Tipo de Subsidio", valor: this.props.respuestasData.tipoDescripcion },
      { concepto: "Clase de Subsidio", valor: this.props.respuestasData.claseDescripcion },
      { concepto: "Fecha Hecho", valor: this.props.respuestasData.fechaHecho },
    ];
    return _itemsConfirm;
  }

  loadDataReposo() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      { concepto: "Cantidad de Días", valor: this.props.respuestasData.cantDiasSubsidio },
      { concepto: "Diagnóstico Médico", valor: this.props.respuestasData.diagnostico },
      { concepto: "Hospital", valor: this.props.respuestasData.hospitalDescripcion },
      { concepto: "Nombre del Médico", valor: this.props.respuestasData.medicoDescripcion },
    ];
    if (this.props.respuestasData.claseSubsidio !== 210) 
    _itemsConfirm.push({ concepto: "Enfermedad", valor: this.props.respuestasData.enfermedadDescripcion })
    return _itemsConfirm;
  }

  loadDataRecienNacido() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      {
        concepto: "Nombre Completo",
        valor: `${this.props.respuestasData.primerApellidoRn} ${this.props.respuestasData.segundoApellidoRn || ""}, ${this.props.respuestasData.primerNombreRn} ${this.props.respuestasData.segundoNombreRn || ""}`,
      },
      { concepto: "Sexo", valor: this.props.respuestasData.sexoRn === "F" ? "Femenino" : "Masculino" },
      { concepto: "Fecha de Nacimiento", valor: this.props.respuestasData.fechaNacimientoRn },
      { concepto: "Nacionalidad", valor: this.props.respuestasData.nacRnDescripcion },
      { concepto: "Libro", valor: this.props.respuestasData.libro },
      { concepto: "Folio", valor: this.props.respuestasData.folio },
      { concepto: "Acta", valor: this.props.respuestasData.acta },
    ];
      return _itemsConfirm;
    }

  loadDataConyuge() {
    let _itemsConfirm = [];
    _itemsConfirm = [
      {
        concepto: "Nombre Completo",
        valor: `${this.props.respuestasData.primerApellidoCon} ${this.props.respuestasData.segundoApellidoCon || ""}, ${this.props.respuestasData.primerNombreCon} ${this.props.respuestasData.segundoNombreCon || ""}`,
      },
      { concepto: "Número de Cédula", valor: separadorPuntoMiles(this.props.respuestasData.cedulaCon) },
      { concepto: "Fecha de Nacimiento", valor: this.props.respuestasData.fechaNacimientoCon },
      { concepto: "Nacionalidad", valor: this.props.respuestasData.nacDescripcionCon },
    ];
      return _itemsConfirm;
    }


  /***************************************************
 * AGREGAR SUBSIDIO DE ACUERDO AL TIPO DE SUBSIDIO *
 ***************************************************/

   agregarSubsidio = () => {
    if(this.props.respuestasData.tipoSubsidio === 5) this.agregarTipoReposo();
    if(this.props.respuestasData.claseSubsidio === 2) this.agregarTipoPremioRecienNac();
    if(this.props.respuestasData.claseSubsidio === 3) this.agregarTipoPremioMatrimonio();
  }

  agregarTipoReposo = () => {
    let datos = {
      "cedula": this.props.respuestasData.nroCedula,
      "idAhorro": this.props.respuestasData.idAhorro,
      "tipoSubsidio": this.props.respuestasData.tipoSubsidio,
      "claseSubsidio": this.props.respuestasData.claseSubsidio,
      "fechaHecho": this.props.respuestasData.fechaHecho,
      "diasSolicitado": this.props.respuestasData.cantDiasSubsidio,
      "diagnostico": this.props.respuestasData.diagnostico,
      "idMedico": this.props.respuestasData.nroMedico,
      "idHospital": this.props.respuestasData.nroHospital,
      "idEnfermedad": this.props.respuestasData.nroEnfermedad || null,
      // "fechaPresentacion": formatDate(new Date(), 'DD-MM-YYYY'),
      "canal":"WEB"
    }
    console.log(datos);
    this.sendRequestSubsidio(datos);
  }

  agregarTipoPremioRecienNac = () => {
    let datos = {
      "cedula": +this.props.respuestasData.nroCedula,
      "idAhorro": this.props.respuestasData.idAhorro,
      "tipoSubsidio": this.props.respuestasData.tipoSubsidio,
      "claseSubsidio": this.props.respuestasData.claseSubsidio,
      "fechaHecho": this.props.respuestasData.fechaHecho,
      "primerNombreRn": this.props.respuestasData.primerNombreRn,
      "segundoNombreRn": this.props.respuestasData.segundoNombreRn,
      "primerApellidoRn": this.props.respuestasData.primerApellidoRn,
      "segundoApellidoRn": this.props.respuestasData.segundoApellidoRn,
      "sexoRn": this.props.respuestasData.sexoRn,
      "fechaNacimientoRn": this.props.respuestasData.fechaNacimientoRn,
      "nacionalidadRn": this.props.respuestasData.nacionalidadRn,
      "libro": this.props.respuestasData.libro,
      "folio": this.props.respuestasData.folio,
      "acta": this.props.respuestasData.acta,
      "primerNombreCon": this.props.respuestasData.primerNombreCon,
      "segundoNombreCon": this.props.respuestasData.segundoNombreCon,
      "primerApellidoCon": this.props.respuestasData.primerApellidoCon,
      "segundoApellidoCon": this.props.respuestasData.segundoApellidoCon,
      "cedulaCon": this.props.respuestasData.cedulaCon,
      "fechaNacimientoCon": this.props.respuestasData.fechaNacimientoCon,
      "nacionalidadCon": this.props.respuestasData.nacionalidadCon,
      // "fechaPresentacion": formatDate(new Date(), 'DD-MM-YYYY'),
      "canal":"WEB"
    }
    //console.log(datos);
    this.sendRequestSubsidio(datos);
  }

  agregarTipoPremioMatrimonio = () => {
    let datos = {
      "cedula": this.props.respuestasData.nroCedula,
      "idAhorro": this.props.respuestasData.idAhorro,
      "tipoSubsidio": this.props.respuestasData.tipoSubsidio,
      "claseSubsidio": this.props.respuestasData.claseSubsidio,
      "fechaHecho": this.props.respuestasData.fechaHecho,
      "primerNombreCon": this.props.respuestasData.primerNombreCon,
      "segundoNombreCon": this.props.respuestasData.segundoNombreCon,
      "primerApellidoCon": this.props.respuestasData.primerApellidoCon,
      "segundoApellidoCon": this.props.respuestasData.segundoApellidoCon,
      "cedulaCon": this.props.respuestasData.cedulaCon,
      "fechaNacimientoCon": this.props.respuestasData.fechaNacimientoCon,
      "nacionalidadCon": this.props.respuestasData.nacionalidadCon,
      // "fechaPresentacion": formatDate(new Date(), 'DD-MM-YYYY'),
      "canal":"WEB"
    }
    this.sendRequestSubsidio(datos);
  }

  sendRequestSubsidio = (datos) => {
    let fileCedula = this.props.respuestasData.fileCedula;
    let fileCertificado = this.props.respuestasData.fileCertificado;
    let fileAnalisis = this.props.respuestasData.fileAnalisis;
    let fileAdopcion = this.props.respuestasData.fileAdopcion;
    let dataSend = {
      ...datos,
      //"fechaPresentacion": formatDate(new Date(), 'DD-MM-YYYY')
    }

    trackPromise(
      SubsidiosService.confirmarSubsidio(dataSend, fileCedula, fileCertificado, fileAnalisis, fileAdopcion)
      .then((response) => {
        let data = JSON.stringify(response.data);
        let jsonData = JSON.parse(data);
          if (jsonData.codigo === 0) {
              this.props.respuestaServ(jsonData.datos);
              this.nextStep.click();
          }
          else {
          Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
            return;
          }
        }
        ));
  }  

  volver = (e) => {
    this.props.previousStep();
  }

  // mayusculaPrimeraLetra(sentence = "") {
  //   const palabra = sentence.toLowerCase().split(" ");
  //   palabra.forEach((el, i) => {
  //     palabra[i] = el.charAt(0).toUpperCase() + el.slice(1)
  //   })
  //   return palabra.join(" ")
  // }

  render() {
    return (
        <div>
          <div className="row">
            <div className="steps clearfix steps-doc">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                     
                      <span className="title_text current">
                        Selección de Cuenta
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      
                      <span className="title_text">
                        {this.props.respuestasData.tipoSubsidio === 5 && "Datos de Reposo" ||
                         this.props.respuestasData.claseSubsidio === 2 && "Recién Nacido" ||
                         this.props.respuestasData.claseSubsidio === 3 && "Datos Cónyuge"}
                      </span>
                    </div>
                  </span>
                </li>
                {this.props.respuestasData.claseSubsidio === 2 && (
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">
                        
                        <span className="title_text">Datos Cónyuge</span>
                      </div>
                    </span>
                  </li>
                )}
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                     
                      <span className="title_text">Adjuntar Documentos</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                     
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <DatosSocio />
          </div>
        </div>

          <div className="row justify-content-md-center">
            <div className="col-md-10">
              <span>
                Cuenta a Acreditar: {this.props.respuestasData.datosCuenta}
              </span>
              <div
                className="inner"
                // style={{ paddingTop: 2, paddingBottom: 1 }}
              >
                <p style={{ margin: 1 }}>
                  Tipo: {mayusculaPrimeraLetra(this.props.respuestasData.tipoDescripcion)}
                </p>
                <p style={{ margin: 1 }}>
                  Clase: {mayusculaPrimeraLetra(this.props.respuestasData.claseDescripcion)}
                </p>
                <p style={{ margin: 1 }}>
                  Fecha Hecho: {this.props.respuestasData.fechaHecho}
                </p>
         
                {
                  (this.props.respuestasData.claseSubsidio === 210) && 
                  <h6 style={{ marginTop: '8px', fontSize: '1.1rem' }}>
                    Monto a Recibir: {separadorPuntoMiles(this.props.respuestasData.montoARecibir * this.props.respuestasData.cantDiasSubsidio) + ' GS.'}
                  </h6>
                }
                {
                  (this.props.respuestasData.claseSubsidio !== 210) && 
                  <h6 style={{ marginTop: '8px', fontSize: '1.1rem' }}>
                    Monto a Recibir: {separadorPuntoMiles(this.props.respuestasData.montoARecibir) + ' GS.'}
                  </h6>
                }

               
              </div>
            </div>
          </div>

          <br />

          <div className="row justify-content-md-center">
            <div className="col-md-10">
              {this.props.respuestasData.tipoSubsidio === 5 && (
                <DataTable
                  columns={this.getColumn()}
                  data={this.loadDataReposo()}
                  title="Datos de Reposo"
                  noTableHead={true}
                  customStyles={{
                    rows: { style: { minHeight: "30px" } },
                  }}
                  getTheadGroupProps={() => {
                    return { style: { display: "none" } };
                  }}
                />
              )}
              {this.props.respuestasData.claseSubsidio === 2 && (
                <DataTable
                  columns={this.getColumn()}
                  data={this.loadDataRecienNacido()}
                  title="Datos del Recién Nacido"
                  noTableHead={true}
                  customStyles={{
                    rows: { style: { minHeight: "30px" } },
                  }}
                  getTheadGroupProps={() => {
                    return { style: { display: "none" } };
                  }}
                />
              )}
              {this.props.respuestasData.tipoSubsidio === 4 && (
                <DataTable
                  columns={this.getColumn()}
                  data={this.loadDataConyuge()}
                  title="Datos del Cónyuge"
                  noTableHead={true}
                  customStyles={{
                    rows: { style: { minHeight: "30px" } },
                  }}
                  getTheadGroupProps={() => {
                    return { style: { display: "none" } };
                  }}
                />
              )}
            </div>
          </div>

          <br />

          <hr />

          <div className="row">
            <div className="col-md-6">
                <label
                  className="input-label-bold float-left"
                  style={{ marginTop: 10 }}
                >
                  Esta seguro que desea CONFIRMAR la operación?
                  <br />
                </label>
            </div>
            <div className="col-lg-3 col-md-3">
             
                <button
                  className="btn btn-cu-quintary btn-consulta"
                  onClick={this.volver}
                >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
                </button>
               
              
            </div>
            <div className="col-lg-3 col-md-3">
            <button
                  className="btn btn-cu-primary"
                  onClick={() => {
                    this.agregarSubsidio();
                  }}
                >
                  {" "}
                  Confirmar <FontAwesomeIcon icon={faArrowRight} />
                </button>
                <button
                  hidden
                  ref={(a) => (this.nextStep = a)}
                  className="btn btn-cu-primary"
                  onClick={this.props.nextStep}
                ></button>
            </div>
          </div>
        </div>
      );
  }
}